import { VoidPaymentDetailRequest } from "./void-payment-detail-request";

export class VoidPaymentRequest {
    details: Array<VoidPaymentDetailRequest>;
    invoiceCode: string;
    createInvoice: boolean;
    customerCode: string;
    branchCode: string;
    salesOrgCode: string;
    amount: number;
    constructor() {
        this.details = [];
        this.invoiceCode = "";
        this.createInvoice = false;
        this.customerCode = "";
        this.branchCode = "";
        this.salesOrgCode = "";
        this.amount = 0;
    }
}